import { callEndpoint, checkClientToken } from '../../backend';

export const isUsernameAvailable = async (username, signal) => {
  const isAvailable = await callEndpoint(
    callEndpoint.endpoints.isUsernameAvailable,
    {
      username,
    },
    undefined,
    signal,
  );
  return isAvailable;
};

export const updateProfile = async (profile) => {
  const { title, username, imageData } = profile;
  await callEndpoint(callEndpoint.endpoints.updateProfile, {
    title,
    username,
    image: imageData,
  });
  return checkClientToken();
};

export const saveUsername = async (username) => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, {
    username,
  });
};

export const getHomeLocation = async () => {
  const response = await callEndpoint(callEndpoint.endpoints.getHomeLocation);
  return { ...response };
};

export const submitHomeLocation = async (
  homeLocation,
  homeLocationLatLon,
  homeLocationCountry,
) => {
  await callEndpoint(callEndpoint.endpoints.submitMemberHomeLocation, {
    homeLocation,
    homeLocationLatLon,
    homeLocationCountry,
  });
};

export const getMemberWatercrafts = async (memberId) => {
  const response = await callEndpoint(
    callEndpoint.endpoints.getMemberWatercrafts,
    {
      memberId,
    },
  );
  return response.watercrafts;
};

export const getExistingFloatPlanContacts = async (memberId) => {
  const response = await callEndpoint(
    callEndpoint.endpoints.getExistingFloatPlanContacts,
    {
      memberId,
    },
  );

  return response;
};

export const getExistingFloatPlanContactsForSpecificFloatPlan = async (
  memberId,
  floatPlanId,
) => {
  const response = await callEndpoint(
    callEndpoint.endpoints.getExistingFloatPlanContacts,
    {
      memberId,
      floatPlanId,
    },
  );
  return response.floatPlanExistingContacts;
};

/**
 * This fetches the users trips within a specified time range
 *
 * @param {Object} parameters an object containing the query parameters
 * @param {number | string} parameters.id trip owner id
 * @param {string} [parameters.dateRangeStart] optional timestamp for the date range start
 * @param {string} [parameters.dateRangeEnd] optional timestamp for the date range end
 * @returns {Object} containing the users trips & total trip stats { trips, statistics }
 */
export const getMemberTrips = async ({
  id: memberID,
  dateRangeStart = undefined,
  dateRangeEnd = undefined,
}) => {
  const response = await callEndpoint(callEndpoint.endpoints.getTrips, {
    memberID,
    dateRangeStart,
    dateRangeEnd,
  });

  return { trips: response.trips, statistics: response.statistics };
};

export const editMemberTrip = async (tripDetails) => {
  await callEndpoint(callEndpoint.endpoints.updateTripDetails, tripDetails);
};

export const submitBoatDetails = async (boatDetails) => {
  const { imageData, ...rest } = boatDetails;
  const response = await callEndpoint(callEndpoint.endpoints.addWatercraft, {
    ...rest,
    image: imageData || null,
  });
  return response;
};

export const editBoatDetails = async (boatDetails) => {
  const { imageData, ...rest } = boatDetails;
  const response = await callEndpoint(callEndpoint.endpoints.editWatercraft, {
    ...rest,
    image: imageData || null,
  });
  return response;
};

export const getMemberInterests = async () => {
  const interests = await callEndpoint(
    callEndpoint.endpoints.getMemberInterests,
  );
  return interests;
};

export const dismissCompleteProfileChecklist = async () => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, {
    isProfileChecklistDismissed: true,
  });
};

/**
 * Returns the best way on how to display a members name, this
 * is used due to a members username can be null. This functions narrows
 * down each possible way to display a users name.
 *
 * Username > Title > Email
 *
 * @param {Object} member
 *
 * @returns {String} members display name
 */
export const getMemberDisplayName = (member) => {
  if (member.username?.trim()?.length > 0) {
    return member.username;
  }

  if (member.title?.trim()?.length > 0) {
    return member.title;
  }

  return member.email;
};
